import styled from 'styled-components';

import { COLORS } from '../../../../theme/tokens';
import { Text } from '../../../../components/Text/Text';

/**
 * The switch cluster beside the page title: status word, then the switch.
 *
 * The bottom margin mirrors `SectionTitle`'s, so both boxes centre on the same
 * line inside the header row instead of the switch riding above the heading.
 */
export const Root = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
`;

/** The state in words, so the switch is readable without decoding its colour. */
export const StatusText = styled(Text)`
  font-size: 13px;
  color: ${COLORS.textMuted};
  white-space: nowrap;
`;
